// Themes
export const THEMES = {
  DEFAULT: 'DEFAULT',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  INDIGO: 'INDIGO',
}

// Invites
// TODO: figure out a way to do this without hardcoding
export const MANAGER = 'Manager'
export const ADMIN = 'Admin'
export const EMPLOYEE = 'Employee'
export const MANAGER_INVITE_ROLES = [MANAGER, EMPLOYEE]
export const ADMIN_INVITE_ROLES = [ADMIN, MANAGER, EMPLOYEE]
export const MANAGER_EDIT_ROLES = [EMPLOYEE]
export const ADMIN_EDIT_ROLES = [ADMIN, MANAGER, EMPLOYEE]

export const DEFAULT_AVATAR = '/static/img/avatargs/default.jpg'

// Default threshold below which data coverage triggers warning banner
export const DEFAULT_DATA_COVERAGE_THRESHOLD = 75

// Default number of days to look back when suggesting a new date range from the warning banner
export const DEFAULT_DAYS_LOOKBACK = 30

// Threshold above which percentage changes are hidden on stat cards (likely low data in before period)
export const PERCENT_CHANGE_THRESHOLD = 300
